import cx from "classnames"
import PropTypes from "prop-types"
import { Text } from "components/Text"

export function Fees(props) {
  const { className, title, children, ...rest } = props

  const classNames = cx("space-y-4 px-5", className)

  return (
    <div className={classNames} {...rest}>
      {title ? (
        <Text variant="headline5" className="text-primary-dark">
          {title}
        </Text>
      ) : null}
      {children}
    </div>
  )
}

Fees.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
}
